import { observer } from 'mobx-react-lite'
import { BlogMetadataRecord } from 'api/clients/BlogMetadataRecordsClient'
import { useBlogMetadataComposition } from './hooks/useBlogMetadataComposition'
import { WordPressBlogMetadataLayout, GoHighLevelBlogMetadataLayout, WixBlogMetadataLayout } from './components'

type Props = {
  articleId: string
  initialData?: BlogMetadataRecord
}

export const BlogMetadataV2 = observer(({ articleId, initialData }: Props) => {
  const composition = useBlogMetadataComposition({
    articleId,
    initialData,
  })

  // Route to integration-specific layouts
  if (composition.states.integrationState.isWixIntegration) {
    return <WixBlogMetadataLayout {...composition} />
  }

  if (composition.states.integrationState.isGoHighLevelIntegration) {
    return <GoHighLevelBlogMetadataLayout {...composition} />
  }

  // WordPress or default
  return <WordPressBlogMetadataLayout {...composition} />
})
